import { Injectable } from '@tanbo/vue-di-plugin'
import { ElMessage } from 'element-plus'
import type { ComposerTranslation } from 'vue-i18n'
import { SecurityEventService } from './security-event.service'
import { DisposeActionType } from './constants/enums'
import { buildHandlingRequest } from './dispose-strategy-builder'
import type { DisposePayload, SecurityEventDetail } from './types'
import { Http } from '@/services/http'

@Injectable()
export class SecurityEventDisposeService {
  constructor (
    private securityEventService: SecurityEventService,
    private http: Http
  ) {}

  async execute (
    detail: SecurityEventDetail,
    payload: DisposePayload,
    t: ComposerTranslation
  ): Promise<boolean> {
    try {
      switch (payload.action) {
        case DisposeActionType.KillProcess:
          await this.killProcess(detail)
          await this.securityEventService.markHandled(detail.business_id)
          break
        default: {
          const handlingReq = buildHandlingRequest(detail, payload)
          if (!handlingReq) {
            throw new Error('unsupported dispose action')
          }
          await this.securityEventService.submitHandling(handlingReq)
          break
        }
      }
      ElMessage.success(t('securityEvent.disposeSuccess'))
      return true
    } catch (e) {
      console.error(e)
      ElMessage.error(t('securityEvent.disposeFail'))
      return false
    }
  }

  private async killProcess (detail: SecurityEventDetail) {
    await this.http.post('/terminal-order/close_process', {
      device_id: detail.device_id,
      pid: detail.process_pid,
      path: detail.process_path,
    })
  }
}
